"use client";

import { registerPlugin } from "@capacitor/core";

type HiiveInstantsPlugin = {
  captureViewport(): Promise<{ dataUrl: string }>;
  setScreenProtected(input: { protected: boolean }): Promise<void>;
  getCapabilities(): Promise<{ torch: boolean }>;
  setTorch(input: { enabled: boolean }): Promise<void>;
  openSettings(): Promise<void>;
  saveImage(input: {
    base64: string;
    mimeType: string;
    fileName: string;
  }): Promise<{ saved: boolean }>;
  saveVideo(input: {
    path: string;
    mimeType: string;
    fileName: string;
  }): Promise<{ saved: boolean }>;
  downloadToCache(input: {
    url: string;
    fileName: string;
  }): Promise<{ path: string }>;
};

// Instants and feed media share one native plugin. Keep the proxy across
// module re-evaluation too, since Capacitor retains its own registration.
const runtime = globalThis as typeof globalThis & {
  __hiiveInstantsPlugin?: HiiveInstantsPlugin;
};

runtime.__hiiveInstantsPlugin ??=
  registerPlugin<HiiveInstantsPlugin>("HiiveInstants");

export const HiiveInstants = runtime.__hiiveInstantsPlugin;
